/**
 * Main Entry Point
 * CSSとSvelte Custom Elementsをロードします
 */

// Tailwind CSS (PostCSS処理)
import '/common/css/style.css';

// scroll-hint のベース CSS は SCSS 経由（_custom.scss → _scroll-hint.scss）で
// style.css に含める。node_modules の CSS 直接 import はビルド時に style.css へ
// バンドルされず本番（CMS）でヒントが表示されないため、ここでは読み込まない。

// ベースレイヤー (default-package)
import '/common/css/base/style.scss';
import '/common/css/base/partspage.scss';

// カスタムSCSS - プロジェクト固有オーバーライド (Sass → PostCSS処理)
import '/common/css/_custom.scss';
import '/common/css/_employment.scss';
import '/common/css/_news.scss';
import '/common/css/_stories.scss';

// Svelteコンポーネント
import '/common/components/register.js';

// バニラ JS イニシャライザ（ビルドモードで data-* 要素を初期化、dev では何もしない）
import './initializers.js';

// 共通ユーティリティ
import './utils.js';


console.log('✅ Page loaded');
